import React, { useRef, useState } from "react";
import { Link } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import http from '../../services/http';
import { Toast } from 'primereact/toast';
import { InputMask } from "primereact/inputmask";
import { useNavigate } from 'react-router-dom';


export default function PasswordRecover() {

    const navigate = useNavigate();

    const toast = useRef(null);
    const [value, setValue] = useState('Email') // 'Email' or 'Phone'

    const emailFormik = useFormik({
        initialValues: {
            email: '',
        },
        validationSchema: Yup.object({
            email: Yup.string().email("Email inválido").required("Email é obrigatório"),
        }),
        onSubmit: values => {
            var data = {
                email: values.email
            }

            http.post('password/reset/', data).then( (response) => {
                toast.current.show({ severity: 'success', summary: 'Sucesso', detail: response.data.message, life: 4000 });
            }).catch((error) => {
                toast.current.show({ severity: 'warn', summary: 'Ops', detail: JSON.stringify(error.response.data), life: 4000 });
            })
        }
    });

    const phoneFormik = useFormik({
        initialValues: {
            phone: '',
        },
        validationSchema: Yup.object({
            phone: Yup.string().required('Telefone é obrigatório'),
        }),
        onSubmit: values => {
            var data = {
                phone: values.phone.replace(/\D/g, '')
            }

            http.post('password/reset/phone/', data).then( (response) => {
                toast.current.show({ severity: 'success', summary: 'Sucesso', detail: 'Caso seu telefone esteja cadastrado, você receberá um código de 6 dígitos para recuperar sua senha.', life: 4000 });

                setTimeout(() => {
                    navigate(`/verify-code/${response.data.uid}`)
                }, 4000)
            }).catch((error) => {
                toast.current.show({ severity: 'warn', summary: 'Ops', detail: JSON.stringify(error.response.data), life: 4000 });
            })
        }
    });

    return (
        <div className="row mt-5">
            
            <Toast ref={toast} position="top-right" />

            <div className="col-md-6 offset-md-3">
                <div className="divBorder formMarginBottom">
                    <h1 className="text-center mb-4">Recuperar Senha</h1>

                    <div className="p-4">
                        <div className="row">
                            <div className="col-12">
                            <div className="mb-4">
                                <div>
                                    <label className="form-label fw-bold">Recuperar senha usando</label>
                                </div>
                                <div className={`form-check form-check-inline selectRadioGroup ${value === 'Email' ? 'active' : null}`} onClick={() => setValue('Email')} style={{ cursor: 'pointer' }}>
                                    <input name='options' className="form-check-input" type="radio" checked={value === 'Email' ? true : false} onChange={() => setValue('Email')} />
                                    <label className='form-check-label'>Email</label>
                                </div>
                                <div className={`form-check form-check-inline selectRadioGroup ${value === 'Phone' ? 'active' : null}`} onClick={() => setValue('Phone')} style={{ cursor: 'pointer' }}>
                                    <input name='options' className="form-check-input" type="radio" checked={value === 'Phone' ? true : false} onChange={() => setValue('Phone')} />
                                    <label className='form-check-label'>Telefone</label>
                                </div>
                            </div>
                            </div>
                        </div>

                        {/* Email Form Content */}
                        {value === 'Email' && (
                            <form className="row g-2" onSubmit={emailFormik.handleSubmit}>
                                <div className="col-12">
                                    <label className="form-label">Insira seu Email</label>
                                    <input type="email" name="email" className="form-control" required {...emailFormik.getFieldProps('email')} />
                                    {emailFormik.errors.email ? (<span name="email" className="text-vermelho">{emailFormik.errors.email}</span>) : null}
                                </div>
                                <div className="d-grid mx-auto btnMargin">
                                    <button className="btn btn-success btn-rounded" type="submit">Recuperar Senha</button>
                                </div>
                            </form>
                        )}

                        {/* Phone Form Content */}
                        {value === 'Phone' && (
                            <form className="row g-2" onSubmit={phoneFormik.handleSubmit}>
                                <div className="col-12">
                                    <label className="form-label">Insira seu Telefone</label>
                                    <InputMask 
                                        name="phone"
                                        className='form-control' 
                                        style={{'padding': '0.37rem 0.75rem'}} 
                                        mask='(99) 99999-9999' 
                                        value={phoneFormik.values.phone} 
                                        onChange={(e) => phoneFormik.setFieldValue('phone', e.target.value)} 
                                        placeholder="(11) 99999-9999"
                                    />
                                    {phoneFormik.errors.phone ? (<span name="phone" className="text-vermelho">{phoneFormik.errors.phone}</span>) : null}
                                </div>
                                <div className="d-grid mx-auto btnMargin">
                                    <button className="btn btn-success btn-rounded" type="submit">Recuperar Senha</button>
                                </div>
                            </form>
                        )}

                        <hr className="mt-4" />
                        <div className="noLogin text-center">
                            <p>Já possui cadastro?</p>
                            <div className="d-grid mx-auto col-4">
                                <Link className="btn btn-outline-success btn-rounded" to={'/'}>Login</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}